import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AccessDataForm from '~/components/forms/AccessDataForm';
import Loader from '~/components/Loader';
import { PageContainer, Container as DefaultContainer } from '~/pages/common';
import { ToastCtx } from '~/providers/ToastProvider';
import { users } from '~/helpers/api';
import messages from '~/helpers/api/messages';
import Header from '~/compositions/Header';
import devices from '~/styles/devices';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const Container = styled.div`
  padding: 21px;
  display: none;

  @media (min-width: ${devices.tablet}) {
    display: block;
  }
`;

export default function AccessData() {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const toast = useContext(ToastCtx);
  const user = useSelector(state => state.user);
  const breadcrumbs = useContext(BreadcrumbsContext);

  function setBreadcrumb(icon, label) {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('key', 'Alterar dados de acesso');
    return () => setBreadcrumb();
    // eslint-disable-next-line
  }, []);

  async function handleSubmit(formPayload) {
    const { currentPassword, newPassword, confirmNewPassword } = formPayload;
    const payload = {
      currentPassword,
      password: newPassword,
      confirmPassword: confirmNewPassword,
    };

    try {
      setIsLoading(true);
      const response = await users.changeAccessData(payload);
      toast.dispatch(messages(response, 'change_access_data'));
      history.push('/home');
    } catch (e) {
      let msg;
      if (e.messages.find(item => item.code === '-27')) {
        msg = 'Nova senha deve ser diferente das anteriores';
      }
      if (e.messages.find(item => item.code === '-28')) {
        msg = 'Senha atual inválida';
      }
      toast.dispatch(messages(e, 'change_access_data', <>&#128577; {msg}</>));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Container>
        <Header />
      </Container>
      <PageContainer>
        <DefaultContainer fullWidth>
          <Loader isLoading={isLoading}>
            <AccessDataForm onSubmit={handleSubmit} email={user?.email} />
          </Loader>
        </DefaultContainer>
      </PageContainer>
    </>
  );
}
